import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { SlidersHorizontal } from 'lucide-react'
import { DEFAULT_COLUMNS } from '@/lib/reports/space-yield/types'

interface ColumnPickerProps {
  visibleColumns: string[]
  onColumnsChange: (columns: string[]) => void
  hasFuelData?: boolean
}

export function ColumnPicker({ visibleColumns, onColumnsChange }: ColumnPickerProps) {
  const colSet = new Set(visibleColumns)

  const toggleColumn = (colId: string) => {
    if (colSet.has(colId)) {
      onColumnsChange(visibleColumns.filter((c) => c !== colId))
    } else {
      onColumnsChange([...visibleColumns, colId])
    }
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="h-9">
          <SlidersHorizontal className="w-4 h-4 mr-2" />
          Columns
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-56 p-3" align="end">
        <div className="space-y-1">
          <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">
            Columns
          </p>
          {DEFAULT_COLUMNS.map((col) => (
            <div
              key={col.id}
              className="flex items-center gap-2 cursor-pointer py-1"
              onClick={() => toggleColumn(col.id)}
            >
              <Checkbox checked={colSet.has(col.id)} className="pointer-events-none" />
              <span className="text-sm">{col.label}</span>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  )
}
